// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

// shared components
import { CancelButton } from '@/components/ui/button';

interface UnsavedChangesDialogProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Dialog that warns users about unsaved changes when attempting to navigate away
 */
const UnsavedChangesDialog = ({
  open,
  onStay,
  onLeave,
}: UnsavedChangesDialogProps) => {
  const { t } = useTranslation('energyxplorer-tree-tab');

  return (
    <Dialog
      data-testid="unsaved-changes-dialog"
      open={open}
      onClose={onStay}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle data-testid="unsaved-changes-dialog-title">
        {t('unsaved_changes_dialog.title')}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            {t('unsaved_changes_dialog.description')}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <CancelButton
          onClick={onStay}
          data-testid="unsaved-changes-stay-button"
        >
          {t('unsaved_changes_dialog.stay')}
        </CancelButton>

        <Button
          data-testid="unsaved-changes-leave-button"
          onClick={onLeave}
          variant="contained"
          color="error"
        >
          {t('unsaved_changes_dialog.leave')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
